
const StatusBar = () => {
  return (
    <div className="bg-transparent h-12 flex items-center justify-between px-6 text-sm font-semibold text-black pt-8">
      <span>9:41</span>
      <div className="flex items-center gap-1">
        <div className="flex gap-1">
          <div className="w-1 h-1 bg-black rounded-full"></div>
          <div className="w-1 h-1 bg-black rounded-full"></div>
          <div className="w-1 h-1 bg-black rounded-full"></div>
          <div className="w-1 h-1 bg-gray-400 rounded-full"></div>
        </div>
        <div className="w-6 h-3 border border-black border-r-0 rounded-l-sm">
          <div className="w-4 h-2 bg-green-500 rounded-l-sm mt-0.5"></div>
        </div>
        <div className="w-1 h-1 bg-black rounded-sm"></div>
      </div>
    </div>
  );
};

export default StatusBar;
